import React, { useLayoutEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import twemoji from 'twemoji';

import { EMOJI_LIB_ENDPOINT_BASE } from '../../../constants/pro-custom-prints';

const propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
};

const EmojiParsed = ({ text, className = 'emoji-inline', ...props }) => {
  const ref = useRef(null);

  useLayoutEffect(() => {
    if (!ref.current) return;
    twemoji.parse(ref.current, {
      base: `${EMOJI_LIB_ENDPOINT_BASE}/`,
      folder: 'svg',
      ext: '.svg',
      className,
    });
  }, [text, className]);

  if (!text) {
    return '';
  }

  return (
    <span ref={ref} {...props}>
      {text}
    </span>
  );
};

EmojiParsed.propTypes = propTypes;

export default EmojiParsed;
